/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const AICalc = require('../AICalc');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const SINGLE_TARGET_ABILITIES = ['arrow_shot', 'razor_shot', 'void_spike', 'infect_mind'];
const AOE_ABILITIES = ['multi_shot', 'fumigate', 'lightning', 'molotov_cocktail'];

const Q_which_ranged_attack = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  // branch indexes
  node.ARROW_SHOT = 'arrow_shot';
  node.VOID_SPIKE = 'void_spike';
  node.MULTI_SHOT = 'multi_shot';
  node.RAZOR_SHOT = 'razor_shot';
  node.INFCT_MIND = 'infect_mind';
  node.FUMIGATE = 'fumigate';
  node.LIGHTNING = 'lightning';
  node.MOLOTOV = 'molotov_cocktail';
  node.NO_RANGED_ABILITIES = 'no_ranged_abilities';

  let equipped_ranged_abilities = [...SINGLE_TARGET_ABILITIES, ...AOE_ABILITIES].filter(
    (ability_handle) => BattleCalc.getEquippedAbility(node.actor, ability_handle)
  );

  // this is not the AoE branch, so don't use AoE abilities unless no single-target abilities are equipped
  if (equipped_ranged_abilities.some((ability) => SINGLE_TARGET_ABILITIES.includes(ability)))
    equipped_ranged_abilities = equipped_ranged_abilities.filter(
      (ability) => !AOE_ABILITIES.includes(ability)
    );

  node.branches[node.ARROW_SHOT] = new UseAbility(actor, 'arrow_shot');
  node.branches[node.VOID_SPIKE] = new UseAbility(actor, 'void_spike');
  node.branches[node.MULTI_SHOT] = new UseAbility('multi_shot');
  node.branches[node.RAZOR_SHOT] = new UseAbility(actor, 'razor_shot');
  node.branches[node.INFCT_MIND] = new UseAbility(actor, 'infect_mind');
  node.branches[node.FUMIGATE] = new UseAbility(actor, 'fumigate');
  node.branches[node.LIGHTNING] = new UseAbility(actor, 'lightning');
  node.branches[node.MOLOTOV] = new UseAbility(actor, 'molotov_cocktail');
  node.branches[node.NO_RANGED_ABILITIES] = new TreeNode(null, null);

  node.query = function (target) {
    // filter out AoE abilities if they would harm allies too much
    const usable_ranged_abilities = equipped_ranged_abilities.filter((ability_handle) => {
      // Single-target abilities are always OK
      if (!AOE_ABILITIES.includes(ability_handle)) {
        return true;
      }

      // For multi_shot, always allow it (only hits enemies)
      if (ability_handle === 'multi_shot') {
        return true;
      }

      // For other AoE abilities, use generic damage prediction
      const abilityTarget = ability_handle === 'fumigate' ? actor : target;
      return AICalc.isAoESafe(
        actor,
        ability_handle,
        abilityTarget,
        battleState,
        1.5 // Enemy damage must be 50% more than ally damage
      );
    });

    if (usable_ranged_abilities.length) {
      const random_ranged_ability =
        usable_ranged_abilities[Math.floor(Math.random() * usable_ranged_abilities.length)];
      return node.branches[random_ranged_ability].query(
        random_ranged_ability === 'fumigate'
          ? node.actor
          : ['infect_mind', 'razor_shot'].includes(random_ranged_ability)
            ? AICalc.getBestDoTTarget(actor, target, battleState)
            : target
      );
    } else {
      return node.branches[node.NO_RANGED_ABILITIES].query();
    }
  };

  return node;
};
module.exports = Q_which_ranged_attack;
